import { render, staticRenderFns } from "./BeVenueSlider.vue?vue&type=template&id=0e56ccaf&scoped=true"
import script from "./BeVenueSlider.vue?vue&type=script&lang=js"
export * from "./BeVenueSlider.vue?vue&type=script&lang=js"
import style0 from "./BeVenueSlider.vue?vue&type=style&index=0&id=0e56ccaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56ccaf",
  null
  
)

export default component.exports